import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { CustomPageSearchProvider } from './context/custom-page-search-context';
import { CustomPageSearchComponent } from './custom-page-search-component';

export function CustomPageSearchFactory() {
    return (
        <BaseLayoutFactory>
            <CustomPageSearchProvider>
                <CustomPageSearchComponent />
            </CustomPageSearchProvider>
        </BaseLayoutFactory>
    );
}
